import { pinia } from '@/stores'
import { OperationType, useUserStore } from '@/stores/user.store'
import type {
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
  RouteLocationNormalizedLoadedGeneric
} from 'vue-router'

export function beforeEnter(
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedLoadedGeneric,
  next: NavigationGuardNext
) {
  const userStore = useUserStore(pinia)
  const operationType = userStore.decodedToken?.productionSequenceOperation.operation.type

  const isHomeRoute = to.name === 'home'
  const isShippingOperation = operationType === OperationType.SHIPPING

  const shouldRedirectToShipping = isHomeRoute && isShippingOperation

  if (shouldRedirectToShipping) {
    return next({ name: 'shipping' })
  }

  return next()
}

export default {
  beforeEnter
} as const
